import { render, staticRenderFns } from "./vendasPontuadas.vue?vue&type=template&id=15fefad4"
import script from "./vendasPontuadas.ts?vue&type=script&lang=js&external"
export * from "./vendasPontuadas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fefad4')) {
      api.createRecord('15fefad4', component.options)
    } else {
      api.reload('15fefad4', component.options)
    }
    module.hot.accept("./vendasPontuadas.vue?vue&type=template&id=15fefad4", function () {
      api.rerender('15fefad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/historicoEnviosDotz/vendasPontuadas.vue"
export default component.exports